import React, { useState, useEffect } from 'react';
import { Modal, Transfer, message, Spin } from 'antd';
import axiosInstance from '../../services/axiosServicesVisit';

const AssignSpecificSamplesModal = ({ visible, onCancel, delegate }) => {
    const [targetKeys, setTargetKeys] = useState([]);
    const [allSamples, setAllSamples] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        if (visible && delegate) {
            setLoading(true);
            const fetchSamples = axiosInstance.get('/v1/samples?page=1&limit=1000');
            const fetchDelegateDetails = axiosInstance.get(`/v1/delegates/${delegate.id}`);

            Promise.all([fetchSamples, fetchDelegateDetails])
                .then(([samplesRes, delegateRes]) => {
                    // On convertit l'ID en string pour allSamples
                    const all = samplesRes.data?.data.map(s => ({ 
                        key: String(s.id), 
                        title: s.name 
                    })) || [];
                    setAllSamples(all);
                    
                    // On convertit les IDs assignés en string pour targetKeys
                    const assignedIds = delegateRes.data?.specificSamples?.map(s => String(s.id)) || [];
                    setTargetKeys(assignedIds);
                })
                .catch(() => message.error("Erreur de chargement des données."))
                .finally(() => setLoading(false));
        }
    }, [visible, delegate]);

    const handleChange = (newTargetKeys) => {
        setTargetKeys(newTargetKeys);
    };

    const handleOk = async () => {
        setSubmitLoading(true);
        try {
            // On renvoie les IDs au format nombre (integer) pour le Backend
            await axiosInstance.post(`/v1/delegates/${delegate.id}/assign-specific-samples`, {
                sampleIds: targetKeys.map(key => parseInt(key, 10))
            });
            message.success("Assignation des demandes spécifiques mise à jour.");
            onCancel();
        } catch (error) {
            message.error("Erreur lors de la mise à jour.");
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <Modal
            title={`Assigner des Demandes Spécifiques à ${delegate?.firstname} ${delegate?.lastname}`}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            width={800}
            confirmLoading={submitLoading}
            destroyOnClose
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}><Spin /></div>
            ) : (
                <Transfer
                    dataSource={allSamples}
                    targetKeys={targetKeys}
                    onChange={handleChange}
                    render={item => item.title}
                    listStyle={{ width: '47%', height: 400 }}
                    showSearch
                    titles={['Disponibles', 'Assignés (Spécifiques)']}
                    filterOption={(inputValue, option) => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1}
                />
            )}
        </Modal>
    );
};

export default AssignSpecificSamplesModal;